import React from 'react';

const Hero = () => {
  return (
    <div className="relative bg-white">
      <div 
        className="absolute inset-0 bg-cover bg-center z-0"
        style={{
          backgroundImage: `url('https://media.gadventures.com/media-server/cache/27/e9/27e9d41d3bffb4ad7068c0454e6367b7.jpg')`,
        }}
      ></div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 lg:py-32">
        <div className="flex flex-col lg:flex-row items-center">
          <div className="lg:w-1/2 lg:pr-8 bg-white bg-opacity-90 p-8 rounded-lg">
            <div className="flex items-center mb-4">
              <div className="bg-gadventures-purple rounded-full p-1 mr-2">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <p className="text-gadventures-purple font-semibold text-sm">Small Group Adventures</p>
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-4">
              Experience The World <br />
              Through Authentic <br />
              Small Group Travel
            </h1>
            <p className="text-lg text-gray-600 mb-8">
              Join like-minded travelers on immersive adventures with G Adventures. 
              <span className="font-bold text-gadventures-purple"> Create lifelong memories and meaningful connections. </span>
            </p>
            <a
              href="#get-started"
              className="inline-block w-full sm:w-auto px-6 py-3 bg-gadventures-purple text-white font-bold rounded-lg text-center hover:bg-gadventures-purple-dark transition duration-300"
            >
              Start Your Adventure
            </a>
            <div className="mt-6 flex items-center">
              <div className="flex -space-x-2 overflow-hidden">
                {[1, 2, 3].map((index) => (
                  <img
                    key={index}
                    className="inline-block h-8 w-8 rounded-full ring-2 ring-white"
                    src={`https://randomuser.me/api/portraits/men/${index}.jpg`}
                    alt=""
                  />
                ))}
              </div>
              <span className="ml-3 text-sm font-semibold text-gray-700">Join thousands of satisfied travelers</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
